import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { clearCABuilder, createCustomAudience, getFacebookPixels, setValue } from 'redux/modules/customAudiences';
import Measure from 'react-measure';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import CABEntrySection from './CABEntrySection';
import CABPixelSection from './CABPixelSection';
import CABFileSection from './CABFileSection';
var CABuilder = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  var websiteTrafficForm = state.forms && state.forms["websiteTrafficForm_".concat(orgId)] ? _objectSpread({}, state.forms["websiteTrafficForm_".concat(orgId)]) : null;
  var validationErrors = websiteTrafficForm && websiteTrafficForm.validationErrors ? websiteTrafficForm.validationErrors : null;
  var fileForm = state.forms && state.forms["fileForm_".concat(orgId)] ? _objectSpread({}, state.forms["fileForm_".concat(orgId)]) : null; //    const validationErrors2 = fileForm && fileForm.validationErrors2 ? fileForm.validationErrors2 : null;

  return {
    theme: state.theme,
    facebookPixels: state.ads.facebookPixels && state.ads.facebookPixels[orgId] ? state.ads.facebookPixels[orgId] : [],
    websiteTrafficForm: websiteTrafficForm,
    fileForm: fileForm,
    organization: state.organization.current,
    audienceName: state.customAudiences.audienceName,
    audienceType: state.customAudiences.audienceType,
    isCreatingCustomAudience: state.customAudiences.isCreatingCustomAudience,
    customAudienceError: state.customAudiences.customAudienceError
  };
}, {
  clearCABuilder: clearCABuilder,
  createCustomAudience: createCustomAudience,
  getFacebookPixels: getFacebookPixels,
  setValue: setValue
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(CABuilder, _Component);

  var _super = _createSuper(CABuilder);

  function CABuilder() {
    var _this;

    _classCallCheck(this, CABuilder);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "canSaveAudience", function () {
      var val = false;
      var _this$props = _this.props,
          audienceType = _this$props.audienceType,
          audienceName = _this$props.audienceName,
          isCreatingCustomAudience = _this$props.isCreatingCustomAudience,
          websiteTrafficForm = _this$props.websiteTrafficForm,
          fileForm = _this$props.fileForm;

      if (isCreatingCustomAudience) {
        return false;
      }

      switch (audienceType) {
        case 'pixel':
          val = (websiteTrafficForm.inclusions.length > 0 || websiteTrafficForm.exclusions.length > 0) && audienceName.length > 0 && audienceName.length <= 50;
          break;

        case 'file':
          val = audienceName.length > 0 && audienceName.length <= 50 && (fileForm.entryType === true ? !!fileForm.audienceFile : fileForm.emailTextInput.length > 0);
          break;

        default:
          break;
      }

      return val;
    });

    _defineProperty(_assertThisInitialized(_this), "saveAudience", function () {
      _this.props.setValue('isCreatingCustomAudience', true);

      var _this$props2 = _this.props,
          audienceType = _this$props2.audienceType,
          audienceName = _this$props2.audienceName,
          websiteTrafficForm = _this$props2.websiteTrafficForm,
          fileForm = _this$props2.fileForm;

      switch (audienceType) {
        case 'pixel':
          return _this.props.createCustomAudience('pixel', _this.props.organization.id, {
            data: {
              inclusions: websiteTrafficForm.inclusions,
              exclusions: websiteTrafficForm.exclusions,
              audienceName: audienceName,
              criteriaOperator: websiteTrafficForm.criteriaOperator
            }
          });

        case 'file':
          return _this.props.createCustomAudience('email', _this.props.organization.id, fileForm.entryType === true ? {
            fields: [{
              key: 'audienceName',
              value: audienceName
            }],
            files: [fileForm.audienceFile]
          } : {
            data: {
              payload: fileForm.emailTextInput,
              audienceName: audienceName
            }
          });

        default:
          return Promise.resolve();
      }
    });

    return _this;
  }

  _createClass(CABuilder, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.getFacebookPixels(this.props.organization.id, this.props.adAccountId);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.clearCABuilder();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement(Dialog, {
        autoScrollBodyContent: true,
        title: "Create An Audience",
        open: this.props.show,
        modal: true,
        actions: [/*#__PURE__*/React.createElement(RaisedButton, {
          label: "Cancel",
          onClick: function onClick() {
            _this2.props.clearCABuilder();

            _this2.props.handleClose();
          },
          disabled: this.props.isCreatingCustomAudience,
          style: {
            marginRight: 24
          }
        }), this.props.audienceType ? /*#__PURE__*/React.createElement(RaisedButton, {
          secondary: true,
          label: "Back",
          onClick: function onClick() {
            _this2.props.setValue('audienceType', null);
          },
          disabled: this.props.isCreatingCustomAudience,
          style: {
            marginRight: 24
          }
        }) : null, /*#__PURE__*/React.createElement(RaisedButton, {
          secondary: true,
          label: "Save",
          onClick: function onClick() {
            if (_this2.canSaveAudience()) {
              _this2.props.setValue('isCreatingCustomAudience', true);

              _this2.saveAudience().then(function () {
                _this2.props.handleClose();
              })["catch"](function (err) {
                console.error(err);
                var errorMessage = err.error.message;

                if (errorMessage.indexOf('Terms of service has not been accepted') !== -1) {
                  errorMessage = 'Custom Audience Terms of Service has not been accepted. Please contact us.';
                }

                _this2.props.setValue('customAudienceError', errorMessage);
              });
            }
          },
          disabled: this.props.isCreatingCustomAudience,
          style: {
            marginRight: 24
          }
        })],
        onRequestClose: this.props.handleClose
      }, /*#__PURE__*/React.createElement(Measure, {
        onMeasure: function onMeasure(dimensions) {
          _this2.setState({
            audienceModalDimensions: dimensions
          });
        },
        whitelist: ['width', 'height'],
        useClone: true
      }, /*#__PURE__*/React.createElement("span", null, this.props.customAudienceError && /*#__PURE__*/React.createElement("p", {
        style: {
          color: 'red'
        }
      }, this.props.customAudienceError), !this.props.audienceType ? /*#__PURE__*/React.createElement(CABEntrySection, null) : this.props.audienceType === 'pixel' ? /*#__PURE__*/React.createElement(CABPixelSection, null) : /*#__PURE__*/React.createElement(CABFileSection, null))));
    }
  }]);

  return CABuilder;
}(Component)) || _class);
export { CABuilder as default };